<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "fill";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.87275 2.82088C2.81263 2.76288 2 3.62655 2 4.61544V15.7322C2 16.7506 2.8179 17.5184 3.7618 17.5716C6.64259 17.7339 9.14746 18.8283 11.3109 20.8856C11.697 21.2527 12.303 21.2527 12.6891 20.8856C14.8525 18.8283 17.3574 17.7339 20.2382 17.5716C21.1821 17.5184 22 16.7506 22 15.7322V4.61544C22 3.62655 21.1874 2.76288 20.1273 2.82088C17.046 2.98946 14.3272 4.06064 12 6.01897C9.67279 4.06064 6.95397 2.98946 3.87275 2.82088ZM4 15.5823V4.83293C6.6725 5.02666 8.99559 6.0098 11 7.79863V18.043C8.92591 16.5748 6.58733 15.7498 4 15.5823ZM13 18.043C15.0741 16.5748 17.4127 15.7498 20 15.5823V4.83293C17.3275 5.02666 15.0044 6.0098 13 7.79863V18.043Z"
    />
    <path
      v-else-if="weight === 'fill'"
      d="M12 7.16133C14.4126 4.86895 17.2698 3.63243 20.5715 3.45179C21.0442 3.42593 21.4286 3.81236 21.4286 4.28575V15.9318C21.4286 16.4052 21.0442 16.7862 20.5715 16.8129C17.2982 16.9973 14.441 18.2502 12 20.5715C9.55892 18.2502 6.70174 16.9973 3.42843 16.8129C2.95579 16.7862 2.57141 16.4052 2.57141 15.9318V4.28575C2.57141 3.81236 2.9558 3.42593 3.42848 3.45179C6.73016 3.63243 9.58732 4.86895 12 7.16133Z"
    />
  </svg>
</template>
